export default "__VITE_ASSET__CFr1FFqM__"